import Vuex from 'vuex'
const getters = {
    getNavSelector(state){return state.navSelector}
}
const mutations = {
    setNavSelector(state,val){
        state.navSelector = val ;
    }
}

export default () => {
    return new Vuex.Store({
        state:{
            navSelector:'index'
        },
        mutations,
        getters
       })
}
